<template>
  <tr class="customer-ortho-arch" :class="{ selected: is_selected }">
    <td class="customer-ortho-arch__active">
      {{ is_active }}
      <i class="fas fa-comment" v-if="has_notes" data-trigger="tooltip" :title="arch.notes"></i>
    </td>
    <td class="customer-ortho-arch__start">
      {{ date_start }}
    </td>
    <td class="customer-ortho-arch__end">
      {{ date_end }}
    </td>
    <td class="customer-ortho-arch__arch">
      {{ arch_position }}
    </td>
    <td class="customer-ortho-arch__caliper">
      {{ arch.caliper }}
    </td>
    <td class="customer-ortho-arch__material">
      {{ arch.material }}
    </td>
    <td class="customer-ortho-arch__type">
      {{ arch.type }}
    </td>
    <td class="customer-ortho-arch__number">
      {{ arch.number }}
    </td>
    <td class="customer-ortho-arch__actions">
      <button type="button" class="btn btn-wabident-round small" @click="$emit('edit', arch)">
        Editar
      </button>
      <button type="button" class="btn btn-wabident-round small red" @click="$emit('delete', arch)">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['arch', 'customer', 'selected_tooth'],
  data() {
    return {
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // UPPER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // UPPER RIGHT
      ],
    }
  },
  computed: {
    has_notes() {
      return this.arch.notes && this.arch.notes != '';
    },
    arch_position() {
      return this.arch.arch == 'upper' ? 'Sup.' : 'Inf.';
    },
    is_selected() {
      let selected_arch = false;

      if (this.arch.arch == 'upper') {
        this.selected_tooth.forEach((t) => {
          if (this.upper_row_adults.includes(Number(t))) {
            selected_arch = true;
          }
        });
      } else {
        this.selected_tooth.forEach((t) => {
          if (this.lower_row_adults.includes(Number(t))) {
            selected_arch = true;
          }
        });
      }

      return this.arch.is_active && selected_arch;
    },
    is_active() {
      return this.arch.is_active ? 'Sí' : 'No';
    },
    date_start() {
      if (this.arch.placement_date) {
        return window.WabiDent.fmtDate(this.arch.placement_date);
      }
      return '';
    },
    date_end() {
      if (this.arch.removal_date) {
        return window.WabiDent.fmtDate(this.arch.removal_date);
      }
      return '';
    },
  },
}
</script>

<style lang="scss">
.customer-ortho-arch__actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
